import {
    ControlWithoutFieldsGraphItemDtoDtoContent,
    StandardAccessRight,
    FinancialYearView,
    DueDateOffsetForMonthOffsetPeriod as MonthDueDateOffset,
    SchedulingOccurrenceChangeForDueDateOffsetForMonthOffsetPeriod as SchedulingOccurrenceChange,
    CalendarView,
    ControlProgramOverviewDtoContent,
} from "api/generated/model";
import { TagsData } from "components/tag/types";
import { ControlAssignmentGroup } from "utils/controls/assignmentUtils";

interface ControlDataRow {
    control: ControlWithoutFieldsGraphItemDtoDtoContent;
    controlProgram: ControlProgramOverviewDtoContent;
    tags: TagsData;
    accessRight: StandardAccessRight | null;
    financialYear: FinancialYearView | null;
    calendar: CalendarView | null;
    assignments: ControlAssignmentGroup[];
    assigneeTags: TagsData;
}

const DEFAULT_DUE_DATE_OFFSET: MonthDueDateOffset = {
    offsetPeriod: {
        months: 0,
        days: 0,
    },
    anchor: "EndOfInterval",
    offsetType: "AfterAnchor",
};

type CustomDueDatesTypedProps<Period> =
    | {
          type: "EDIT";
          onChange: (
              occurrence: Period,
              schedulingChange: SchedulingOccurrenceChange
          ) => void;
      }
    | {
          type: "READ_ONLY";
      };

export {
    type ControlDataRow,
    DEFAULT_DUE_DATE_OFFSET,
    type CustomDueDatesTypedProps,
};
